import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { Dispatch } from 'redux';
import { useEffect } from 'react';
import {
  IntlProvider,
  LocalizationProvider,
  loadMessages,
  load,
} from '@progress/kendo-react-intl';
import { locales, LocaleInterface } from '../../AlertsGrid/GridLocale';
import { CardMedia, createStyles, makeStyles, Theme } from '@material-ui/core';
import { Button } from '@progress/kendo-react-buttons';
import weekData from 'cldr-core/supplemental/weekData.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import caGregorian from 'cldr-dates-full/main/fr/ca-gregorian.json';
import numbers from 'cldr-numbers-full/main/fr/numbers.json';
import dateFields from 'cldr-dates-full/main/fr/dateFields.json';
import timeZones from 'cldr-dates-full/main/fr/timeZoneNames.json';
import esMessages from '../../../utils/gridMessageKey.json';
import { Fade } from '@progress/kendo-react-animation';
loadMessages(esMessages, 'fr-CA');
load(
  likelySubtags,
  currencyData,
  weekData,
  caGregorian,
  numbers,
  dateFields,
  timeZones
);
import StringResourceManager, { GetString } from '../../StringResourceManager';
import {
  getProfileNameList,
  getDrilldownProfileByID,
  fetchNBCItemsByID,
  deleteDrilldown,
  deleteDrilldownItem,
  getDrilldownItemByDrilldownID,
  addNewDrilldown,
  addItemToDrilldown,
  getItemsGroups,
  updateDrilldown,
  getAllNBCImages,
  resetNotificationMessage,
  updateNBCItems,
  updateDrilldownItemPositionByDrilldownID,
} from '../../../store/NBC/NBCAction';
import { NBCItem, NBCProfile } from '../../../Interfaces/NBC/NBCItem';
import {
  Checkbox,
  CheckboxChangeEvent,
  Input,
  InputChangeEvent,
} from '@progress/kendo-react-inputs';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { saveSelectedProfile } from '../../../store/UserSettings/UserSettingsActions';
import _ from 'lodash';
import {
  TreeView,
  TreeViewExpandChangeEvent,
  TreeViewItemClickEvent,
} from '@progress/kendo-react-treeview';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import {
  DrilldownProfile,
  TreeViewDataItem,
} from '../../../Interfaces/NBC/Drilldown';
import FolderIcon from '@mui/icons-material/Folder';
import ScreenshotMonitorIcon from '@mui/icons-material/ScreenshotMonitor';

import {
  ContextMenu,
  MenuSelectEvent,
  Splitter,
  SplitterOnChangeEvent,
} from '@progress/kendo-react-layout';
import { Offset } from '@progress/kendo-react-popup';
import ManageProfileDialog from '../ManageProfileDialog';
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridDataStateChangeEvent,
  isColumnMenuFilterActive,
  isColumnMenuSortActive,
} from '@progress/kendo-react-grid';
import {
  setExpandedState,
  setGroupIds,
} from '@progress/kendo-react-data-tools';
import { DataResult, process, State } from '@progress/kendo-data-query';
import { ColumnMenu, HeaderCustomCell } from '../../ColumnMenus/ColumnMenu';
import { LoadingPanel } from '../../LoadingPanel';
import folderIcon from '../../../assets/svg/folderIcon.svg';
import DynamicDropDownList from '../../DynamicDropDownList';
import {
  DRILLDOWN,
  DRILLDOWN_ITEM,
  NBC_DRILLDOWN,
} from '../../../utils/constants';
import ImageDialog from '../ImageDialog';
import { uploadIcon } from '@progress/kendo-svg-icons';
import uploadImage from '../../../assets/svg/uploadImage.svg';
import ApplySnapshotDialog from '../ApplySnapshotDialog';
import {
  Notification,
  NotificationGroup,
} from '@progress/kendo-react-notification';
import { ResultResponse } from '../../../Interfaces/ResultResponse';
import { NBCItemGroups } from '../../../Interfaces/NBC/NBCItemGroups';
import { DndContext, DragEndEvent, closestCenter } from '@dnd-kit/core';
import { SortableContext, arrayMove, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbarButton: {
      height: 40,
      minWidth: 160,
      marginRight: 5,
    },
    drilldownContainer: {
      display: 'grid',
    },
    drilldownButton: {
      display: 'flex',
      padding: '5px',
    },
    dialogContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      maxWidth: '300px',
      padding: '20px',
    },
    icon: {
      marginRight: 8,
      color: '#fbc02d',
    },
    mainLayout: {
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
    },
    topRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      height: '28vh',
      maxHeight: '35vh',
      flexShrink: 0,
    },
    bottomSection: {
      maxHeight: '52vh',
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxSizing: 'border-box',
      overflow: 'auto',
    },
    dropdownList: {
      width: '150px',
      marginRight: '5px',
      height: 40,
    },
    span: {
      display: 'flex',
      alignItems: 'center',
    },
    menuItem: {
      display: 'block',
      fontWeight: 500,
      cursor: 'pointer',
      '&:hover': {
        color: 'blue',
      },
    },
    fontSize: {
      fontSize: '0.9rem',
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      gap: 8,
      flexWrap: 'wrap',
    },
    imageContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      margin: '10px',
      padding: '8px',
      width: 80,
      height: 100,
      boxSizing: 'border-box',
    },
    image: {
      width: 50,
      height: 50,
      borderRadius: '4px',
    },
    imageLabel: {
      marginTop: '4px',
      fontSize: '11px',
      color: '#333',
      textAlign: 'center',
      wordBreak: 'break-word',
      maxWidth: '70px',
      whiteSpace: 'normal',
    },
    imageWrapper: {
      position: 'relative',
      display: 'inline-block',
      '&:hover $tooltip': {
        visibility: 'visible',
        opacity: 1,
      },
    },
    tooltip: {
      visibility: 'hidden',
      opacity: 0,
      transition: 'opacity 0.3s ease',
      width: 200,
      backgroundColor: '#fff',
      color: '#000',
      textAlign: 'left',
      borderRadius: '4px',
      padding: '10px',
      boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
      position: 'absolute',
      zIndex: 10,
      top: '100%',
      left: '50%',
      transform: 'translateX(-20%)',
      whiteSpace: 'normal',
    },
    hide: {
      visibility: 'hidden',
      opacity: '0 !important',
    },
    overlay: {
      position: 'absolute',
      top: '20%',
      left: '10%',
      width: '80%',
    },
    card: {
      width: 100,
      height: 100,
      cursor: 'pointer',
      border: '1px solid #ccc',
    },
    snapShotIcon: {
      marginTop: '-5px',
      marginLeft: '5px',
    },
    bottomRight: {
      right: 0,
      bottom: 0,
      alignItems: 'flex-start',
      flexWrap: 'wrap-reverse',
    },
    error: {
      fontSize: '1.5rem',
    },
  })
);

const SortableImageItem = ({
  item,
  children,
}: {
  item: any;
  children: React.ReactNode;
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: item.Key ?? item.DrilldownID,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {children}
    </div>
  );
};

const DrilldownContainer: React.FC = ({}): React.ReactElement => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();
  const tdStyle: any = { textAlign: 'center' };

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0]
  );

  const CREATE_DRILLDOWN = GetString('CREATE_DRILLDOWN_BUTTON');

  const SELECT_PROFILE = GetString('SELECT_PROFILE');

  const LABEL_TITLE_ENGLISH = GetString('COLUMN_TITLE_ENGLISH');

  const LABEL_TITLE_FRENCH = GetString('COLUMN_TITLE_FRENCH');

  const LABEL_TITLE_SPANISH = GetString('COLUMN_TITLE_SPANISH');

  const LABEL_IS_ENABLED = GetString('LABEL_IS_ENABLED');

  const LABEL_IS_VISIBLE = GetString('LABEL_IS_VISIBLE');

  const ADD_BUTTON = GetString('ADD_DRILLDOWN_BUTTON');

  const DELETE_DRILLDOWN_BUTTON = GetString('DELETE_DRILLDOWN_BUTTON');

  const EDIT_BUTTON = GetString('EDIT_BUTTON');

  const DELETE_BUTTON = GetString('DELETE_BUTTON');

  const SELECT_IMAGE = GetString('SELECT_IMAGE');

  const EDIT_DRILLDOWN = GetString('EDIT_DRILLDOWN');

  const EDIT_ITEM = GetString('EDIT_ITEM');

  const profileNames: NBCProfile[] = useSelector(
    (state: ApplicationState) => state.nbcReducer.profileNames
  );

  const selectedProfile: string | undefined = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedProfile
  );

  const drilldownProfile: DrilldownProfile = useSelector(
    (state: ApplicationState) => state.nbcReducer.drilldownProfile
  );

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage
  );

  const fetchingNBCItems: boolean = useSelector(
    (state: ApplicationState) => state.nbcReducer.fetchingNbcItems
  );

  const fetchingDrilldown: boolean = useSelector(
    (state: ApplicationState) => state.nbcReducer.fetchingDrilldown
  );

  const drilldownItems: string[] | null = useSelector(
    (state: ApplicationState) => state.nbcReducer.drilldownItems
  );

  const itemsGroups: NBCItemGroups[] = useSelector(
    (state: ApplicationState) => state.nbcReducer.groups
  );

  const imageList: string[] = useSelector(
    (state: ApplicationState) => state.nbcReducer.nbcImages
  );

  const applySnapshotResponse: ResultResponse = useSelector(
    (state: ApplicationState) => state.nbcReducer.response
  );

  const profileOnChange = (event: DropDownListChangeEvent) => {
    saveSelectedProfile(
      dispatch,
      profileNames.find(a => a.ProfileName === event.target.value)?.ProfileUuid
    );

    const profileId = profileNames.find(
      item =>
        item.ProfileUuid ===
        profileNames.find(a => a.ProfileName === event.target.value)
          ?.ProfileUuid
    )?.ProfileId;

    if (profileId !== undefined) {
      getDrilldownProfileByID(dispatch, profileId);
      fetchNBCItemsByID(dispatch, profileId);
    }

    setSelectedId(null);
    setDrilldownItemCodes([]);
    setDrilldownItem([]);
  };

  const [createDrilldownVisible, setCreateDrilldownVisible] =
    React.useState<boolean>(false);

  const [data, setData] = React.useState<TreeViewDataItem[]>([]);

  const [selectedId, setSelectedId] = React.useState<string | null>(null);

  const [drilldownItemCodes, setDrilldownItemCodes] = React.useState<string[]>(
    []
  );

  const initialFormValues: TreeViewDataItem = {
    DrilldownID: '',
    English: '',
    French: '',
    Spanish: '',
    IsVisible: false,
    IsEnabled: false,
  };

  const [formValues, setFormValues] =
    React.useState<TreeViewDataItem>(initialFormValues);

  const [manageProfileModalVisible, setManageProfileModalVisible] =
    React.useState<boolean>(false);

  const onExpandChange = (event: TreeViewExpandChangeEvent) => {
    event.item.expanded = !event.item.expanded;
    setData([...data]);
  };

  const [drilldownItem, setDrilldownItem] = React.useState<any[]>([]);

  const [isMovingItems, setIsMovingItems] = React.useState<boolean>(false);

  useEffect(() => {
    if (drilldownItem && Array.isArray(drilldownItem) && isMovingItems) {
      const extractedData = drilldownItem.map(item =>
        item.Code ? item.Code : item.English
      );

      updateDrilldownItemPositionByDrilldownID(
        dispatch,
        profileNames.find(item => selectedProfile === item.ProfileUuid)
          ?.ProfileId,
        selectedId,
        extractedData
      );
      setIsMovingItems(false);
    }
  }, [drilldownItem]);

  function getDrilldownByName(
    nodes: TreeViewDataItem[],
    name: string | null
  ): TreeViewDataItem | undefined {
    for (const node of nodes) {
      if (node.English === name) {
        return node;
      }

      if (node.items?.length) {
        const result = getDrilldownByName(node.items, name);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  useEffect(() => {
    getAllNBCImages(dispatch);
  }, []);

  useEffect(() => {
    if (selectedId) {
      getDrilldownItemByDrilldownID(
        dispatch,
        profileNames.find(item => selectedProfile === item.ProfileUuid)
          ?.ProfileId,
        selectedId
      );
    }
  }, [drilldownProfile]);

  useEffect(() => {
    const items: any[] = [];

    drilldownItemCodes.forEach(code => {
      const matchedItem = nbcItems.find(item => item.Code === code);
      if (matchedItem) {
        items.push(matchedItem);
      } else {
        items.push(getDrilldownByName(drilldownProfile.TreeViewDataItem, code));
      }
    });

    setDrilldownItem(items);
  }, [selectedId]);

  useEffect(() => {
    const items: any[] = [];

    if (drilldownItems) {
      drilldownItems.forEach(code => {
        const matchedItem = nbcItems.find(item => item.Code === code);
        if (matchedItem) {
          items.push(matchedItem);
        } else {
          let drilldown = getDrilldownByName(
            drilldownProfile.TreeViewDataItem,
            code,
          );
          if (drilldown) items.push(drilldown);
        }
      });
    }

    setDrilldownItem(items);
  }, [drilldownItems]);

  const toggleSelectionById = (
    items: TreeViewDataItem[],
    clickedId: string
  ): TreeViewDataItem[] =>
    items.map(item => {
      const isSame = item.DrilldownID === clickedId;
      const newSelected = isSame ? !item.selected : false;

      return {
        ...item,
        selected: newSelected,
        items: item.items ? toggleSelectionById(item.items, clickedId) : [],
      };
    });

  const expandAllAncestorsOfId = (
    items: TreeViewDataItem[],
    targetId: string
  ): TreeViewDataItem[] => {
    const hasDescendant = (children: TreeViewDataItem[]): boolean =>
      children.some(
        child =>
          child.DrilldownID === targetId ||
          (child.items && hasDescendant(child.items))
      );

    return items.map(item => {
      if (item.items && hasDescendant(item.items)) {
        return {
          ...item,
          expanded: true,
          items: expandAllAncestorsOfId(item.items, targetId),
        };
      }

      return {
        ...item,
        items: item.items ? expandAllAncestorsOfId(item.items, targetId) : [],
      };
    });
  };

  const onItemClick = (event: TreeViewItemClickEvent) => {
    const clickedId = event.item.DrilldownID;
    const clickedItemSelected = event.item.selected ?? false;

    setSelectedId(clickedItemSelected ? null : clickedId);

    setData(prevData => {
      const toggled = toggleSelectionById(prevData, clickedId);
      const expanded = expandAllAncestorsOfId(toggled, clickedId);
      return expanded;
    });

    if (!clickedItemSelected) {
      getDrilldownItemByDrilldownID(
        dispatch,
        drilldownProfile.ProfileID,
        clickedId
      );
    } else {
      setDrilldownItem([]);
    }
  };

  const handleChange = (field: keyof TreeViewDataItem, value: any) => {
    setFormValues((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAddNode = () => {
    const newNode: TreeViewDataItem = {
      DrilldownImage: imagePath,
      English: formValues.English,
      French: formValues.French,
      Spanish: formValues.Spanish,
      expanded: false,
      selected: false,
      items: [],
      IsEnabled: formValues.IsEnabled,
      IsVisible: formValues.IsVisible,
      ParentID: selectedId,
    };

    addNewDrilldown(
      dispatch,
      profileNames.find(item => selectedProfile === item.ProfileUuid)
        ?.ProfileId,
      newNode
    );

    setImagePath(undefined);
    setFormValues(initialFormValues);
    setCreateDrilldownVisible(false);
  };

  useEffect(() => {
    getProfileNameList(dispatch);
  }, []);

  useEffect(() => {
    if (
      profileNames.find(item => selectedProfile === item.ProfileUuid)?.ProfileId
    ) {
      getDrilldownProfileByID(
        dispatch,
        profileNames.find(item => selectedProfile === item.ProfileUuid)
          ?.ProfileId
      );

      getItemsGroups(
        dispatch,
        profileNames.find(item => selectedProfile === item.ProfileUuid)
          ?.ProfileId
      );
    }
  }, [profileNames]);

  useEffect(() => {
    setData(drilldownProfile.TreeViewDataItem);
  }, [drilldownProfile]);

  const getDrilldownLanguage = (item: any) => {
    switch (selectedLanguage) {
      case 'English':
        return item.English;
      case 'French':
        return item.French;
      case 'Spanish':
        return item.Spanish;
      default:
        return item.English;
    }
  };

  const renderTreeItem = (props: any) => {
    const { item } = props;

    const handleContextMenu = (e: React.MouseEvent) => {
      offset.current = { left: e.pageX, top: e.pageY };

      e.preventDefault();

      const updatedSelection = (
        items: TreeViewDataItem[]
      ): TreeViewDataItem[] =>
        items.map(i => {
          const isSame = i.DrilldownID === item.DrilldownID;
          return {
            ...i,
            selected: isSame,
            items: i.items ? updatedSelection(i.items) : [],
          };
        });

      setData(prev => updatedSelection(prev));
      setSelectedId(item.DrilldownID);

      getDrilldownItemByDrilldownID(
        dispatch,
        drilldownProfile.ProfileID,
        item.DrilldownID
      );
      setShow(true);
    };

    return (
      <div onContextMenu={handleContextMenu} className={classes.span}>
        <FolderIcon className={classes.icon} />
        {getDrilldownLanguage(item)}
      </div>
    );
  };

  const [show, setShow] = React.useState<boolean>(false);
  const offset = React.useRef<Offset>({ left: 0, top: 0 });

  const [horizontalPanes, setHorizontalPanes] = React.useState<Array<any>>([
    { size: '25%', resizable: true },
    { resizable: true },
  ]);

  const [verticalPanes, setVerticalPanes] = React.useState<Array<any>>([
    { size: '36%', resizable: true },
    { resizable: true },
  ]);

  const [itemToDelete, setItemToDelete] = React.useState<string>('');

  const [itemType, setItemType] = React.useState('');

  const [drilldownIDToDelete, setDrilldownIDToDelete] =
    React.useState<string>('');

  const findParentId = (
    items: TreeViewDataItem[],
    drilldownId: string
  ): string | null => {
    for (const item of items) {
      if (item.items && item.items.length > 0) {
        const child = item.items.find(
          child => child.DrilldownID === drilldownId
        );
        if (child) {
          return item.DrilldownID ?? null;
        }

        const foundInChildren = findParentId(item.items, drilldownId);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }
    return null;
  };

  const handleOnSelect = (e: MenuSelectEvent) => {
    switch (e.item.text) {
      case ADD_BUTTON:
        setCreateDrilldownVisible(true);
        break;
      case DELETE_DRILLDOWN_BUTTON:
        if (selectedId) {
          deleteDrilldown(
            dispatch,
            profileNames.find(item => selectedProfile === item.ProfileUuid)
              ?.ProfileId,
            selectedId
          );

          setSelectedId(
            findParentId(drilldownProfile.TreeViewDataItem, selectedId)
          );
        }

        break;
      case EDIT_BUTTON:
        setEditDrilldownModalVisible(true);
        break;
      case DELETE_BUTTON:
        if (itemType === DRILLDOWN_ITEM) {
          if (selectedId) {
            deleteDrilldownItem(
              dispatch,
              profileNames.find(item => selectedProfile === item.ProfileUuid)
                ?.ProfileId,
              selectedId,
              itemToDelete
            );
          }
          setShowContextMenu(false);
        } else {
          deleteDrilldown(
            dispatch,
            profileNames.find(item => selectedProfile === item.ProfileUuid)
              ?.ProfileId,
            drilldownIDToDelete
          );

          setShowContextMenu(false);
        }
        break;
      default:
    }

    setShow(false);
  };

  const onHorizontalChange = (event: SplitterOnChangeEvent) => {
    setHorizontalPanes(event.newState);
  };

  const onVerticalChange = (event: SplitterOnChangeEvent) => {
    setVerticalPanes(event.newState);
  };

  const CustomMenuItem = (props: any) => {
    const { item } = props;

    return <div className={classes.menuItem}>{item.text}</div>;
  };

  const initialDataState: State = {
    take: 50,
    skip: 0,
    group: [],
  };

  const [dataState, setDataState] = React.useState<State>(initialDataState);

  const [collapsedState, setCollapsedState] = React.useState<string[]>([]);

  const nbcItems: NBCItem[] = useSelector(
    (state: ApplicationState) => state.nbcReducer.nbcItems
  );

  const processWithGroups = (data: any, dataState: State): DataResult => {
    const newDataState = process(data, dataState);

    setGroupIds({ data: newDataState.data, group: dataState.group });
    return newDataState;
  };

  const [resultState, setResultState] = React.useState<DataResult>(
    processWithGroups(nbcItems, dataState)
  );

  const newData = setExpandedState({
    data: resultState.data,
    collapsedIds: collapsedState,
  });

  const dataStateChange = (event: GridDataStateChangeEvent) => {
    const newDataState = processWithGroups(nbcItems, event.dataState);
    setResultState(newDataState);
    setDataState(event.dataState);
  };

  const updatedItemKeys: any[] | undefined = [];

  let nbcItemData: NBCItem[] = nbcItems;

  const isItemIDExist = (key: number) => {
    if (!updatedItemKeys.includes(key)) updatedItemKeys.push(key);
  };

  const EnglishCell = (props: GridCellProps) => {
    const [englishText, setEnglishText] = React.useState<any>('');

    React.useEffect(() => {
      if (
        props.dataItem &&
        props.dataItem.Text &&
        props.dataItem.Text.English
      ) {
        setEnglishText(props.dataItem.Text.English);
      }
    }, [props.dataItem]);

    const EnglishTextOnchange = (e: InputChangeEvent) => {
      setEnglishText(e.target.value);
      let updateNBCItem = nbcItemData.map(item => {
        if (item.Key === props.dataItem.Key) {
          return {
            ...item,
            Text: {
              English: e.target.value?.toString(),
              French: item.Text?.French,
              Spanish: item.Text?.Spanish,
            },
          };
        }
        return item;
      });

      nbcItemData = [...updateNBCItem];
      isItemIDExist(props.dataItem.Key);
    };
    return (
      <td style={tdStyle}>
        <Input
          value={englishText}
          onChange={EnglishTextOnchange}
          className={classes.fontSize}
          readOnly
        />
      </td>
    );
  };

  const SpanishCell = (props: GridCellProps) => {
    const [spanishText, setSpanishText] = React.useState<any>('');

    React.useEffect(() => {
      if (
        props.dataItem &&
        props.dataItem.Text &&
        props.dataItem.Text.Spanish
      ) {
        setSpanishText(props.dataItem.Text.Spanish);
      }
    }, [props.dataItem]);

    const SpanishTextOnchange = (e: InputChangeEvent) => {
      setSpanishText(e.target.value);
      let updateNBCItem = nbcItemData.map(item => {
        if (item.Key === props.dataItem.Key) {
          return {
            ...item,
            Text: {
              English: item.Text?.English,
              French: item.Text?.French,
              Spanish: e.target.value?.toString(),
            },
          };
        }
        return item;
      });
      nbcItemData = [...updateNBCItem];
      isItemIDExist(props.dataItem.Key);
    };
    return (
      <td style={tdStyle}>
        <Input
          value={spanishText}
          onChange={SpanishTextOnchange}
          className={classes.fontSize}
          readOnly
        />
      </td>
    );
  };

  const FrenchCell = (props: GridCellProps) => {
    const [frenchText, setFrenchText] = React.useState<any>('');

    React.useEffect(() => {
      if (props.dataItem && props.dataItem.Text && props.dataItem.Text.French) {
        setFrenchText(props.dataItem.Text.French);
      }
    }, [props.dataItem]);

    const FrenchTextOnchange = (e: InputChangeEvent) => {
      setFrenchText(e.target.value);
      let updateNBCItem = nbcItemData.map(item => {
        if (item.Key === props.dataItem.Key) {
          return {
            ...item,
            Text: {
              English: item.Text?.English,
              French: e.target.value?.toString(),
              Spanish: item.Text?.Spanish,
            },
          };
        }
        return item;
      });
      nbcItemData = [...updateNBCItem];
      isItemIDExist(props.dataItem.Key);
    };
    return (
      <td style={tdStyle}>
        <Input
          value={frenchText}
          className={classes.fontSize}
          onChange={FrenchTextOnchange}
          readOnly
        />
      </td>
    );
  };

  const [itemsToAdd, setItemsToAdd] = React.useState<string[]>([]);

  const [disableAdditemButton, setDisableAdditemButton] =
    React.useState<boolean>(true);

  const AddItemsCell = React.memo(({ dataItem }: GridCellProps) => {
    const isChecked = itemsToAdd.includes(dataItem.Code);

    const MarkAdded = React.useCallback(
      (e: CheckboxChangeEvent) => {
        setItemsToAdd(prevItems => {
          const updatedItems = e.value
            ? [...prevItems, dataItem.Code]
            : prevItems.filter(code => code !== dataItem.Code);

          return updatedItems.length > 0 ? updatedItems : [];
        });
      },
      [dataItem.Key]
    );

    return (
      <td style={tdStyle}>
        <Checkbox
          checked={isChecked}
          onChange={MarkAdded}
          disabled={selectedId === null}
        />
      </td>
    );
  });

  useEffect(() => {
    const exists = itemsToAdd.some(key =>
      drilldownItems?.some(code => code === key)
    );

    if (exists) setDisableAdditemButton(true);
    else setDisableAdditemButton(false);
  }, [itemsToAdd]);

  const CodeCell = (props: GridCellProps) => {
    const [code, setCode] = React.useState<any>(props.dataItem.Code ?? '');

    const CodeOnchange = (e: InputChangeEvent) => {
      setCode(e.target.value);
      let updateNBCItem = nbcItemData.map(item => {
        if (item.Key === props.dataItem.Key) {
          return {
            ...item,
            Code: e.value.toString(),
          };
        }
        return item;
      });
      nbcItemData = [...updateNBCItem];
      isItemIDExist(props.dataItem.Key);
    };
    return (
      <td style={tdStyle}>
        <Input
          value={code}
          onChange={CodeOnchange}
          className={classes.fontSize}
          readOnly
        />
      </td>
    );
  };

  const GroupsCell = (props: GridCellProps) => {
    const GroupsOnChange = (e: DropDownListChangeEvent) => {
      let updateNBCItem = nbcItemData.map(item => {
        if (item.Key === props.dataItem.Key) {
          return {
            ...item,
            Group: e.value,
          };
        }
        return item;
      });
      nbcItemData = [...updateNBCItem];
      isItemIDExist(props.dataItem.Key);
    };
    return (
      <td style={tdStyle}>
        <DynamicDropDownList
          data={itemsGroups.map(item => item.GroupName)}
          defaultValue={props.dataItem.Group}
          onChange={GroupsOnChange}
          className={classes.fontSize}
          disabled
        />
      </td>
    );
  };

  useEffect(() => {
    const profileId = profileNames.find(
      item => item.ProfileUuid === selectedProfile
    )?.ProfileId;

    if (profileId !== undefined) {
      fetchNBCItemsByID(dispatch, profileId);
    }
  }, [profileNames]);

  useEffect(() => {
    setResultState(processWithGroups(nbcItems, dataState));

    if (selectedId) {
      getDrilldownItemByDrilldownID(
        dispatch,
        profileNames.find(item => selectedProfile === item.ProfileUuid)
          ?.ProfileId,
        selectedId
      );
    }
  }, [nbcItems]);

  const addItemToDrilldownOnCLick = () => {
    if (selectedId) {
      addItemToDrilldown(
        dispatch,
        profileNames.find(item => selectedProfile === item.ProfileUuid)
          ?.ProfileId,
        itemsToAdd,
        selectedId
      );
    }
    setItemsToAdd([]);
  };

  const [showContextMenu, setShowContextMenu] = React.useState(false);
  const [hideTooltip, setHideTooltip] = React.useState(false);
  const [item, setItem] = React.useState<any>([]);
  const [itemValues, setItemValues] = React.useState<any>();

  const handleContextMenu = (e: React.MouseEvent, item: any) => {
    offset.current = { left: e.pageX, top: e.pageY };

    e.preventDefault();

    setShowContextMenu(true);

    setHideTooltip(true);

    if (item.hasOwnProperty('ImagePath')) {
      setItemType(DRILLDOWN_ITEM);
      setItemToDelete(item.Code);
      setItem(item);
      setItemValues(item);
    } else {
      setItemType(DRILLDOWN);
      setItemToDelete(item.English);
      setDrilldownIDToDelete(item.DrilldownID);
      setItem(item);
      setItemValues(item);
    }
  };

  const handleMouseLeave = () => {
    setHideTooltip(false);
  };

  const handleOnClose = () => {
    setShow(false);
    setShowContextMenu(false);
  };

  const isColumnActive = (field: string, dataState: State) => {
    return (
      isColumnMenuFilterActive(field, dataState.filter) ||
      isColumnMenuSortActive(field, dataState.sort)
    );
  };

  const columnProps = (field: string) => {
    return {
      field: field,
      columnMenu: ColumnMenu,
      headerClassName: isColumnActive(field, dataState) ? 'active' : '',
    };
  };

  const handleFolderClick = (item: any) => {
    const clickedId = item.DrilldownID;
    const selected = item.selected ?? false;

    setSelectedId(selected ? null : clickedId);

    setData(prevData => {
      const toggled = toggleSelectionById(prevData, clickedId);
      const expanded = expandAllAncestorsOfId(toggled, clickedId);
      return expanded;
    });

    getDrilldownItemByDrilldownID(
      dispatch,
      drilldownProfile.ProfileID,
      clickedId
    );
  };

  const selectAndExpandById = (
    items: TreeViewDataItem[],
    clickedId: string
  ): TreeViewDataItem[] => {
    const hasDescendant = (children: TreeViewDataItem[]): boolean =>
      children.some(
        child =>
          child.DrilldownID === clickedId ||
          (child.items && hasDescendant(child.items))
      );

    return items.map(item => {
      const isClicked = item.DrilldownID === clickedId;
      const shouldExpand = item.items && hasDescendant(item.items);

      return {
        ...item,
        selected: isClicked,
        expanded: shouldExpand || isClicked,
        items: item.items ? selectAndExpandById(item.items, clickedId) : [],
      };
    });
  };

  useEffect(() => {
    if (selectedId) {
      setData(prevData => selectAndExpandById(prevData, selectedId));

      getDrilldownItemByDrilldownID(
        dispatch,
        profileNames.find(item => selectedProfile === item.ProfileUuid)
          ?.ProfileId,
        selectedId
      );
    }
  }, [drilldownProfile]);

  const [editDrilldownModalVisible, setEditDrilldownModalVisible] =
    React.useState<boolean>(false);

  const [imagePath, setImagePath] = React.useState<any | undefined>();

  const [showImageDialog, setShowImageDialog] = React.useState<boolean>(false);

  const handleClick = () => {
    setShowImageDialog(true);
  };

  const imageSelected = (image: string) => {
    setImagePath(image);
    setShowImageDialog(false);
  };

  const updateDrilldownOnClick = () => {
    const updatedNode: TreeViewDataItem = {
      DrilldownID: item.DrilldownID,
      DrilldownImage: imagePath ?? itemValues.DrilldownImage,
      English: itemValues.English,
      French: itemValues.French,
      Spanish: itemValues.Spanish,
      expanded: false,
      selected: false,
      items: [],
      IsEnabled: itemValues.IsEnabled,
      IsVisible: itemValues.IsVisible,
      ParentID: selectedId,
      DrilldownItems: item.DrilldownItems,
    };

    const itemsToUpdate = nbcItemData
      .map(nbcItem => {
        if (nbcItem.Key === item.Key) {
          return {
            ...nbcItem,
            ImagePath: itemValues.DrilldownImage ?? imagePath,
            IsEnabled: itemValues.IsEnabled,
            IsVisible: itemValues.IsVisible,
            Text: {
              English: itemValues.English ?? nbcItem.Text?.English,
              French: itemValues.French ?? nbcItem.Text?.French,
              Spanish: itemValues.Spanish ?? nbcItem.Text?.Spanish,
            },
          };
        }
        return nbcItem;
      })
      .filter(nbcItem => nbcItem.Key === item.Key);

    if (itemType === DRILLDOWN) {
      updateDrilldown(
        dispatch,
        updatedNode,
        profileNames.find(item => selectedProfile === item.ProfileUuid)
          ?.ProfileId,
        item.English
      );
    } else if (itemType === DRILLDOWN_ITEM) {
      updateNBCItems(
        dispatch,
        itemsToUpdate,
        profileNames.find(item => selectedProfile === item.ProfileUuid)
          ?.ProfileId
      );
    }

    setImagePath(undefined);
    setEditDrilldownModalVisible(false);
  };

  const handleUpdateDrilldonOnChange = (
    field: keyof TreeViewDataItem,
    value: any
  ) => {
    setItemValues((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCancel = () => {
    setImagePath(undefined);
    setEditDrilldownModalVisible(false);
  };

  const getItem = (item: any) => {
    if ('ImagePath' in item && item.ImagePath) {
      return item.ImagePath;
    } else if ('ImagePath' in item && !item.ImagePath) {
      return uploadImage;
    } else return folderIcon;
  };

  const [applySnapshotModalVisible, setApplySnapshotModalVisible] =
    React.useState<boolean>(false);

  const [isSnapshotButtonDisabled, setIsSnapshotButtonDisabled] =
    React.useState<boolean>(false);

  const [snapshotNotification, setSnapshotNotification] = React.useState(false);

  useEffect(() => {
    if (applySnapshotResponse.Message != '') {
      setSnapshotNotification(true);
      setTimeout(() => {
        setSnapshotNotification(false);
        resetNotificationMessage(dispatch);
      }, 3000);
    }
  }, [applySnapshotResponse]);

  const clearFetchError = () => {
    resetNotificationMessage(dispatch);
  };

  useEffect(() => {
    const profileData = profileNames.find(
      item => item.ProfileUuid === selectedProfile
    );

    if (profileData?.Divisions) {
      if (profileData?.Divisions?.length > 0)
        setIsSnapshotButtonDisabled(false);
      else setIsSnapshotButtonDisabled(true);
    }
  }, [selectedProfile, profileNames]);

  return (
    <React.Fragment>
      <LocalizationProvider language={currentLocale.language}>
        <IntlProvider locale={currentLocale.locale}>
          {fetchingNBCItems && LoadingPanel}
          <div className={classes.drilldownContainer}>
            <div className={classes.drilldownButton}>
              <DynamicDropDownList
                className={classes.dropdownList}
                data={profileNames.map(a => a.ProfileName)}
                defaultValue={SELECT_PROFILE}
                onChange={profileOnChange}
                value={
                  profileNames.find(
                    item => selectedProfile === item.ProfileUuid
                  )?.ProfileName
                }
              />
              <Button
                type="submit"
                className={classes.toolbarButton}
                onClick={() => setCreateDrilldownVisible(true)}
                disabled={
                  profileNames.find(
                    item => item.ProfileUuid === selectedProfile
                  )
                    ? false
                    : true
                }
              >
                {GetString('CREATE_DRILLDOWN_BUTTON')}
              </Button>
              <Button
                type="submit"
                className={classes.toolbarButton}
                onClick={() => {
                  setManageProfileModalVisible(true);
                }}
              >
                {GetString('MANAGE_PROFILES')}
              </Button>
              <Button
                type="submit"
                className={classes.toolbarButton}
                disabled={
                  selectedId == null ||
                  itemsToAdd.length === 0 ||
                  disableAdditemButton
                }
                onClick={addItemToDrilldownOnCLick}
              >
                {GetString('ADD_ITEM_TO_DRILLDOWN_BUTTON')}
              </Button>
              <Button
                type="submit"
                className={classes.toolbarButton}
                onClick={() => {
                  setApplySnapshotModalVisible(true);
                }}
                disabled={isSnapshotButtonDisabled}
              >
                {GetString('APPLY_SNAPSHOT')}
                <ScreenshotMonitorIcon className={classes.snapShotIcon} />
              </Button>
            </div>
            <div className={classes.mainLayout}>
              <Splitter
                panes={verticalPanes}
                orientation={'vertical'}
                onChange={onVerticalChange}
              >
                <div className={classes.topRow}>
                  <Splitter
                    panes={horizontalPanes}
                    orientation={'horizontal'}
                    onChange={onHorizontalChange}
                  >
                    <div className="pane-content" style={{ margin: '10px' }}>
                      <TreeView
                        data={data}
                        expandIcons={true}
                        onExpandChange={onExpandChange}
                        onItemClick={onItemClick}
                        item={renderTreeItem}
                      />
                      <ContextMenu
                        vertical={true}
                        onSelect={handleOnSelect}
                        onClose={handleOnClose}
                        show={show}
                        offset={offset.current}
                        items={[
                          { text: ADD_BUTTON },
                          { text: DELETE_DRILLDOWN_BUTTON },
                        ]}
                        itemRender={CustomMenuItem}
                      />
                    </div>
                    <div className="pane-content" style={{ margin: '10px' }}>
                      <div className={classes.wrapper}>
                        {fetchingDrilldown && LoadingPanel}
                        <DndContext
                          collisionDetection={closestCenter}
                          onDragEnd={(event: DragEndEvent) => {
                            const { active, over } = event;
                            if (over && active.id !== over.id) {
                              setDrilldownItem(items => {
                                const oldIndex = items.findIndex(
                                  i => (i.Key ?? i.DrilldownID) === active.id
                                );
                                const newIndex = items.findIndex(
                                  i => (i.Key ?? i.DrilldownID) === over.id
                                );
                                return arrayMove(items, oldIndex, newIndex);
                              });

                              setIsMovingItems(true);
                            }
                          }}
                        >
                          <SortableContext
                            items={drilldownItem.map(
                              i => i.Key ?? i.DrilldownID
                            )}
                          >
                            {drilldownItem.map(item => (
                              <SortableImageItem
                                key={item.Key ?? item.DrilldownID}
                                item={item}
                              >
                                <div className={classes.imageContainer}>
                                  <div
                                    className={classes.imageWrapper}
                                    onMouseLeave={handleMouseLeave}
                                  >
                                    <img
                                      src={getItem(item)}
                                      alt="Uploaded"
                                      className={classes.image}
                                      onContextMenu={e =>
                                        handleContextMenu(e, item)
                                      }
                                      onDoubleClick={() => {
                                        if (!item.ImagePath)
                                          handleFolderClick(item);
                                      }}
                                    />
                                    {item.DrilldownImage && (
                                      <img
                                        src={item.DrilldownImage}
                                        alt="Overlay"
                                        className={classes.overlay}
                                        onContextMenu={e =>
                                          handleContextMenu(e, item)
                                        }
                                        onLoad={e => {
                                          const img =
                                            e.target as HTMLImageElement;
                                          img.style.display = 'block';
                                        }}
                                        onError={e => {
                                          const img =
                                            e.target as HTMLImageElement;
                                          img.style.display = 'none';
                                        }}
                                      />
                                    )}
                                    <div
                                      className={`${classes.tooltip} ${
                                        hideTooltip ? classes.hide : ''
                                      }`}
                                    >
                                      {item.Code && (
                                        <div>
                                          <strong>Code:</strong> {item.Code}
                                        </div>
                                      )}
                                      <div>
                                        <strong>English:</strong>{' '}
                                        {item.Text?.English ?? item.English}
                                      </div>
                                      <div>
                                        <strong>French:</strong>{' '}
                                        {item.Text?.French ?? item.French}
                                      </div>
                                      <div>
                                        <strong>Spanish:</strong>{' '}
                                        {item.Text?.Spanish ?? item.Spanish}
                                      </div>
                                      {item.Group && (
                                        <div>
                                          <strong>Group:</strong> {item.Group}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className={classes.imageLabel}>
                                    {item.Text?.English ?? item.English}
                                  </div>
                                </div>
                              </SortableImageItem>
                            ))}
                          </SortableContext>
                        </DndContext>
                        <ContextMenu
                          vertical={true}
                          onSelect={handleOnSelect}
                          onClose={handleOnClose}
                          show={showContextMenu}
                          offset={offset.current}
                          items={[
                            { text: EDIT_BUTTON },
                            { text: DELETE_BUTTON },
                          ]}
                          itemRender={CustomMenuItem}
                        />
                      </div>
                    </div>
                  </Splitter>
                </div>
                <div className={classes.bottomSection}>
                  <Grid
                    style={{ height: '48vh' }}
                    resizable={true}
                    sortable={true}
                    filterable={false}
                    pageable={{
                      buttonCount: 4,
                      pageSizes: [20, 50, 100],
                    }}
                    data={newData}
                    {...dataState}
                    reorderable={true}
                    fixedScroll={false}
                    onDataStateChange={dataStateChange}
                    cells={{
                      headerCell: HeaderCustomCell,
                    }}
                    total={nbcItems.length}
                  >
                    <GridColumn width="50px" cells={{ data: AddItemsCell }} />
                    <GridColumn
                      {...columnProps('Code')}
                      field="Code"
                      title={GetString('COLUMN_TITLE_CODE')}
                      cells={{ data: CodeCell }}
                      columnMenu={ColumnMenu}
                    />
                    <GridColumn
                      {...columnProps('Text.English')}
                      field={'Text.English'}
                      title={GetString('COLUMN_TITLE_ENGLISH')}
                      cells={{ data: EnglishCell }}
                      columnMenu={ColumnMenu}
                    />
                    <GridColumn
                      {...columnProps('Text.French')}
                      field="Text.French"
                      title={GetString('COLUMN_TITLE_FRENCH')}
                      cells={{ data: FrenchCell }}
                      columnMenu={ColumnMenu}
                    />
                    <GridColumn
                      {...columnProps('Text.Spanish')}
                      field="Text.Spanish"
                      title={GetString('COLUMN_TITLE_SPANISH')}
                      cells={{ data: SpanishCell }}
                      columnMenu={ColumnMenu}
                    />
                    <GridColumn
                      {...columnProps('Group')}
                      field="Groups"
                      title={GetString('COLUMN_TITLE_GROUPS')}
                      cells={{ data: GroupsCell }}
                      columnMenu={ColumnMenu}
                    />
                  </Grid>
                </div>
              </Splitter>
            </div>

            {createDrilldownVisible && (
              <Dialog
                title={CREATE_DRILLDOWN}
                onClose={() => setCreateDrilldownVisible(false)}
                style={{ zIndex: 10000 }}
              >
                <div className={classes.dialogContainer}>
                  <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <div className={classes.card}>
                      <CardMedia
                        component="img"
                        alt="Uploaded Image"
                        image={imagePath || uploadImage}
                        height={100}
                        width={100}
                      />
                    </div>
                    <div>
                      <Button
                        onClick={handleClick}
                        style={{ marginLeft: 5, marginRight: 5 }}
                        svgIcon={uploadIcon}
                      >
                        {SELECT_IMAGE}
                      </Button>
                    </div>
                  </div>
                  <div>
                    <label>{LABEL_TITLE_ENGLISH}</label>
                    <Input
                      value={formValues.English}
                      onChange={e => handleChange('English', e.value)}
                    />
                  </div>
                  <div>
                    <label>{LABEL_TITLE_FRENCH}</label>
                    <Input
                      value={formValues.French}
                      onChange={e => handleChange('French', e.value)}
                    />
                  </div>
                  <div>
                    <label>{LABEL_TITLE_SPANISH}</label>
                    <Input
                      value={formValues.Spanish}
                      onChange={e => handleChange('Spanish', e.value)}
                    />
                  </div>
                  <div>
                    <Checkbox
                      label={LABEL_IS_ENABLED}
                      checked={formValues.IsEnabled}
                      onChange={e => handleChange('IsEnabled', e.value)}
                    />
                  </div>
                  <div>
                    <Checkbox
                      label={LABEL_IS_VISIBLE}
                      checked={formValues.IsVisible}
                      onChange={e => handleChange('IsVisible', e.value)}
                    />
                  </div>
                </div>

                <DialogActionsBar>
                  <Button
                    type="button"
                    onClick={handleAddNode}
                    disabled={
                      !formValues.English &&
                      !formValues.French &&
                      !formValues.Spanish
                    }
                  >
                    <StringResourceManager stringKey={'OK_BUTTON'} />
                  </Button>
                  <Button
                    type="button"
                    onClick={() => setCreateDrilldownVisible(false)}
                  >
                    <StringResourceManager stringKey={'CANCEL_BUTTON'} />
                  </Button>
                </DialogActionsBar>
              </Dialog>
            )}
            {manageProfileModalVisible && (
              <ManageProfileDialog
                handleCloseDialog={() => setManageProfileModalVisible(false)}
              />
            )}
            {editDrilldownModalVisible && (
              <Dialog
                title={itemType === DRILLDOWN ? EDIT_DRILLDOWN : EDIT_ITEM}
                onClose={handleCancel}
                style={{ zIndex: 10000 }}
              >
                <div className={classes.dialogContainer}>
                  <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <div className={classes.card}>
                      <CardMedia
                        component="img"
                        alt="Uploaded Image"
                        image={
                          imagePath ||
                          itemValues.DrilldownImage ||
                          itemValues.ImagePath ||
                          uploadImage
                        }
                        height={100}
                        width={100}
                      />
                    </div>
                    <div>
                      <Button
                        onClick={handleClick}
                        style={{ marginLeft: 5, marginRight: 5 }}
                        svgIcon={uploadIcon}
                      >
                        {SELECT_IMAGE}
                      </Button>
                    </div>
                  </div>
                  <div>
                    <label>{LABEL_TITLE_ENGLISH}</label>
                    <Input
                      value={itemValues.English ?? itemValues.Text.English}
                      onChange={e =>
                        handleUpdateDrilldonOnChange('English', e.value)
                      }
                    />
                  </div>
                  <div>
                    <label>{LABEL_TITLE_FRENCH}</label>
                    <Input
                      value={itemValues.French ?? itemValues.Text.French}
                      onChange={e =>
                        handleUpdateDrilldonOnChange('French', e.value)
                      }
                    />
                  </div>
                  <div>
                    <label>{LABEL_TITLE_SPANISH}</label>
                    <Input
                      value={itemValues.Spanish ?? itemValues.Text.Spanish}
                      onChange={e =>
                        handleUpdateDrilldonOnChange('Spanish', e.value)
                      }
                    />
                  </div>
                  <div>
                    <Checkbox
                      label={LABEL_IS_ENABLED}
                      checked={itemValues.IsEnabled}
                      onChange={e =>
                        handleUpdateDrilldonOnChange('IsEnabled', e.value)
                      }
                    />
                  </div>
                  <div>
                    <Checkbox
                      label={LABEL_IS_VISIBLE}
                      checked={itemValues.IsVisible}
                      onChange={e =>
                        handleUpdateDrilldonOnChange('IsVisible', e.value)
                      }
                    />
                  </div>
                </div>

                <DialogActionsBar>
                  <Button type="button" onClick={updateDrilldownOnClick}>
                    <StringResourceManager stringKey={'OK_BUTTON'} />
                  </Button>
                  <Button type="button" onClick={handleCancel}>
                    <StringResourceManager stringKey={'CANCEL_BUTTON'} />
                  </Button>
                </DialogActionsBar>
              </Dialog>
            )}
            {showImageDialog && (
              <ImageDialog
                handleCloseDialog={() => setShowImageDialog(false)}
                imageList={imageList}
                setSelectedImage={imageSelected}
              />
            )}

            {applySnapshotModalVisible && (
              <ApplySnapshotDialog
                handleCloseDialog={() => setApplySnapshotModalVisible(false)}
                modalTitle={'DRILLDOWN_SNAPSHOT_MODAL_TITLE'}
                snapShotType={NBC_DRILLDOWN}
              />
            )}
            <Fade>
              <NotificationGroup className={classes.bottomRight}>
                {snapshotNotification && (
                  <Notification
                    className={classes.error}
                    type={{
                      style: applySnapshotResponse.IsOk ? 'success' : 'error',
                      icon: true,
                    }}
                    closable={true}
                    onClose={() => clearFetchError()}
                  >
                    <StringResourceManager
                      stringKey={applySnapshotResponse.Message}
                    />
                  </Notification>
                )}
              </NotificationGroup>
            </Fade>
          </div> 
        </IntlProvider>
      </LocalizationProvider>
    </React.Fragment>
  );
};

export default DrilldownContainer;
